/**
 * The one slot in the product's visit popup: the confirmation round's chip for a
 * visit in the demo horizon, read-only. A patient who needs a call is the
 * clinician's own row on My day, not an action here — the phone has no
 * confirmation concept and gains none.
 */
import { useOrganization } from "~/providers/GraphqlProvider";
import { ConfirmationChip } from "../../components/ConfirmationChip";
import { isHomeHealthDemoEnabled } from "../../demoEnabled";
import { useDemoSelector } from "../../store/useDemoStore";

export function HomeHealthVisitConfirmation({ visitId }: { visitId: number }) {
  const { organizationName } = useOrganization();
  const enabled = isHomeHealthDemoEnabled(organizationName);
  const inHorizon = useDemoSelector((s) => s.server.visitResources.some((vr) => vr.visitId === visitId));
  const annotation = useDemoSelector((s) => s.annotations[String(visitId)]);
  const channel = useDemoSelector((s) => s.config.confirmationChannel);
  if (!enabled || !inHorizon) return null;
  return <ConfirmationChip annotation={annotation} channel={channel} sx={{ ml: 2, verticalAlign: "text-top" }} />;
}
